import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import requireOperatorAuth from '../Utils/requireOperatorAuth';
import Login from '../Components/Auth/Login';
import ServiceLogin from '../Components/Auth/ServiceLogin';
import PasswordReset from '../Components/Auth/PasswordReset';
import NewPasswordReset from '../Components/Auth/NewPasswordReset';
import Operator from '../Components/Operator/Index';
import Downtime from '../Components/Pages/Downtime';
import Health from '../Components/Pages/Health';

class CommonRoutes extends Component {

    render() {
        return (
            <Switch>
                <Route path='/' component={requireOperatorAuth(Operator)} exact strict />
                <Route path='/login' component={Login} exact strict />
                <Route path='/serviceLogin' component={ServiceLogin} exact strict />
                <Route path='/password-reset' component={PasswordReset} exact strict />
                <Route path='/password-reset/:code' component={NewPasswordReset} exact strict />
                <Route path='/error' component={Downtime} exact strict />
                <Route path='/health' component={Health} exact strict />
            </Switch>
        );
    }
}

export default CommonRoutes;